import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-zoom-tutorial',
  templateUrl: './zoom-tutorial.component.html',
  styleUrls: ['./zoom-tutorial.component.scss'],
})
export class ZoomTutorialComponent implements OnInit {

  @ViewChild('seeTutorial') seeTutorial: any;

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {}

  
  async dismiss() {
    await this.modalCtrl.dismiss({seeTutorial: !this.seeTutorial.el.checked});
  }

}
